module.exports = "<!-- Page Content -->\r\n<div class=\"container\">\r\n    <h3>Sorry! we are unable to load NetId on your current browser. It could be because of your browser settings.</h3>\r\n    <div>If you are are using IE, please make sure you add NetId Url to your trusted zone using following settings through Tools -> Internet Options.<br /><br />\r\n    <div><img src=\"/assets/images/ie_settings.png\"/></div>    <!-- /.row -->\r\n</div>\r\n<!-- /.container -->\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error/error.component.html
// module id = 500
// module chunks = 0